/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GameTrackerPublicControllerDeleteGameUpdateImportant$Params {
  userUuid: string;
  localId: string;
  accessHash: string;
  pbpUuid: string;
  important?: boolean;
}

export function gameTrackerPublicControllerDeleteGameUpdateImportant(http: HttpClient, rootUrl: string, params: GameTrackerPublicControllerDeleteGameUpdateImportant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerPublicControllerDeleteGameUpdateImportant.PATH, 'patch');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('localId', params.localId, {});
    rb.path('accessHash', params.accessHash, {});
    rb.path('pbpUuid', params.pbpUuid, {});
    rb.query('important', params.important, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

gameTrackerPublicControllerDeleteGameUpdateImportant.PATH = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp/{pbpUuid}';
